import React from 'react';

const ContactSection = () => {
  return (


  <>
  
  <section
    className="bg-cover position-relative"
    style={{
      background: 'url(/img/bg-title.jpg) no-repeat',
    }}
    data-overlay="5"
  >
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-xl-7 col-lg-9 col-md-12">
          <div className="fpc-capstion text-center my-4">
            <div className="fpc-captions">
              <h1 className="xl-heading text-light">Contact</h1>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
    <section>
      <div className="container">

        {/* Contact Cards */}
        <div className="row justify-content-between g-4 mb-5">




                     {/* Call Us Card */}
          <div className="col-xl-4 col-lg-4 col-md-6 borderr">
            <div className="card p-4 rounded-4 border br-dashed text-center h-100">
              <div className="crds-icons d-inline-flex mx-auto mb-3 text-orangee fs-2">
                <i className="fa-solid fa-headset"></i>
              </div>
              <div className="crds-desc">
                <h5>Call Us</h5>
                <p className="fs-6 text-md lh-2 mb-0">
  <a href="tel:+917620911746" className="text-decoration-none text-dark">
    +91 7620911746
  </a>
</p>

              </div>
            </div>
          </div>


          {/* Email Card */}
          <div className="col-xl-4 col-lg-4 col-md-6 borderr">
            <div className="card p-4 rounded-4 border br-dashed text-center h-100">
              <div className="crds-icons d-inline-flex mx-auto mb-3 text-orangee fs-2">
                <i className="fa-solid fa-briefcase"></i>
              </div>
              <div className="crds-desc">
                <h5>Drop a Mail</h5>
                <p className="fs-6 text-md lh-2 mb-0">
  <a href="mailto:booking@skylinecabs.com" className="text-decoration-none">
    booking@skylinecabs.com
  </a>
</p>

              </div>
            </div>
          </div>

 

          {/* Social Media Card */}
          <div className="col-xl-4 col-lg-4 col-md-6 borderr">
            <div className="card p-4 rounded-4 border br-dashed text-center h-100 ">
              <div className="crds-icons d-inline-flex mx-auto mb-3 text-orangee fs-2">
              <i className="fa-solid fa-location-dot"></i>
              </div>
              <div className="crds-desc">
                <h5>Address</h5>
                <h6>Skyline Cab</h6>
                <p className="text-md lh-2">Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072</p>
         
              </div>
            </div>
          </div>
        </div>

        {/*Map */}
        <div className="row align-items-center justify-content-between g-4">

   

<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2979.841056312727!2d72.887891!3d19.0984078!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c8701d65fe53%3A0xa64405cba9678f66!2s90%20Feet%20Rd%2C%20Mumbai%2C%20Maharashtra%20400072!5e1!3m2!1sen!2sin!4v1745228300458!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


          </div>
        </div>

    </section>
  </>
  );
};

export default ContactSection;
